{
  "badges": {
    "finnairForBusiness": "Liikematkaetu"
  },
  "ancillaries": {
    "bundle": {
      "seatMapToggle": {
        "includedSeat": "",
        "showSeatMap": ""
      }
    },

    "seat": { "genericTitle": "istuinpaikka" },
    "seatWifi": { "genericTitle": "Istuinpaikka + Internet -kombo" },
    "seatPriority": { "genericTitle": "Istuinpaikka + Priority -kombo" },
    "seatCabinBaggage": {
      "genericTitle": "Istuinpaikka + Käsimatkatavara -kombo"
    },
    "seatMeal": { "genericTitle": "Istuinpaikka + Ateria -kombo" },
    "meal": { "genericTitle": "ateria" },
    "cabinBaggage": { "genericTitle": "käsimatkatavara" },
    "wifi": { "genericTitle": "internet" },
    "priority": { "genericTitle": "priority" },
    "lounge": { "genericTitle": "lounge" },
    "loungeCabinBaggage": {
      "genericTitle": "Lounge + Käsimatkatavara -kombo",
      "extraTitle": "Lounge + Käsimatkatavara -kombo"
    },
    "loungePriority": {
      "genericTitle": "Lounge + Priority -kombo",
      "extraTitle": "Lounge + Priority -kombo"
    },
    "loungeWifi": {
      "genericTitle": "Lounge + Internet -kombo",
      "extraTitle": "Lounge + Internet -kombo"
    },
    "wifiMeal": {
      "genericTitle": "Internet + Ateria -kombo",
      "extraTitle": "Internet + Ateria -kombo"
    },
    "overlappingServicesNotification": {
      "replaceServiceWithBundle": "Kun lisäät tuotteen {currentCategory}, nykyinen {overlapCategory} poistetaan.",
      "replaceMultipleServicesWithBundle": "Kun lisäät tämän kombon, poistuvat nykyiset valintasi, jotka ovat:",
      "convertServiceToSeatBundle": "Tällä kombolla valitsemasi {overlapCategory} yhdistetään istuinpaikkaan ja saat 10 %:n komboalennuksen.",
      "convertSeatBundleToSeatBundle": "Voit valita yhden kombon per istuinpaikka. Jos vaihdat komboa, {currentCategory} korvaa vaihtoehdon {overlapCategory}. Istuinpaikkasi ei muutu.",
      "removeServiceFromBundle": "Tämä {currentCategory} poistaa aiemmin valitun {overlapCategory}.",
      "removeServiceFromSeatBundle": "Tämä {currentCategory} poistaa valitsemaasi komboon kuuluvan {currentCategory}. Istuinpaikkasi säilyy samana, mutta siihen ei enää sisälly 10 %:n komboalennusta.",
      "switchToCombo": "Vaihda tähän komboon",
      "continueToSelect": "Siirry valitsemaan {category}",
      "keepSelection": "Pidä nykyiset valintani"
    }
  }
}
